import { useApolloClient } from '@apollo/client/react';

import {
  useResponderVoiceRecordingPort,
  type ResponderVoiceRecordingPort,
} from '@/shared-responder-v2';
import { CREATE_SURVEY_SIGNED_UPLOAD_URL } from '@/survey-graphql';

// test-exception: Apollo binding only — the port itself lives in @/shared-responder-v2 and its decisions are covered by shared-responder-v2-voice-recording.helpers.spec.ts.
export function useSurveyVoiceRecordingPort(
  isAnonymous: boolean
): ResponderVoiceRecordingPort {
  const client = useApolloClient();

  return useResponderVoiceRecordingPort(async (fileName, mimeType) => {
    const { data } = await client.mutate({
      mutation: CREATE_SURVEY_SIGNED_UPLOAD_URL,
      variables: { input: { fileName, mimeType, isPublic: false } },
    });
    const signed = data?.createSurveySignedUploadUrl ?? null;

    return signed === null ? null : { url: signed.url, path: signed.path };
  }, isAnonymous);
}
